import * as React from 'react';
import PropTypes from 'prop-types';
import { RouteComponentProps } from 'react-router';
import $ from 'jquery';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';

var Config: any = require('../../Config.json');
var selAssetsData;
var lastCheckedNodes = [];
var lastCheckedParentNode = "";
var userId = 1;   //User Id Should get from Login.
var selectedReefers = "";
var selectedUnits = "";

interface UnAssignFromCustomerState {
    isLoading: boolean;
    collapsed: boolean;
    checked: any;
    expanded: any;
    CustomerGroups: Customers[];
    CustomerGroupsList: Customers[];
    SelectedReefers: any[];
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

export class UnassignReefersFromCustomer extends React.Component<any, UnAssignFromCustomerState> {
    myRequest: any;

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true, collapsed: false, CustomerGroups: [], checked: [], expanded: [], CustomerGroupsList: [], SelectedReefers: [], IsCommandIssued: false, PrevSelectedItems: []
        };       
        lastCheckedNodes = [];        
    }

    componentDidMount() {    
        $('#globalLoader').show();
        selAssetsData = this.props.SelectedReefersData;
        if (selAssetsData.length > 0 && selAssetsData != undefined && selAssetsData != null)
            this.setState({ SelectedReefers: selAssetsData }, () => { this.bindCustomerData(this.props.CustomerAccessData); });
            //this.bindCustomerData(this.props.CustomerAccessData);
        selectedReefers = "";
        if (selAssetsData.length > 1) {
            $.each(selAssetsData, function (index, value) {
                selectedReefers = selectedReefers == "" ? this.GetFormatedReefer(value.AssetNumber) : selectedReefers + "," + this.GetFormatedReefer(value.AssetNumber);
            });
        }
        else {
            selectedReefers = this.GetFormatedReefer(selAssetsData[0].AssetNumber);
        }
        $('#globalLoader').hide();
    }
    GetFormatedReefer(reeferId) {
        if (reeferId != null && reeferId != "" && reeferId != undefined) {
            return reeferId.slice(0, 4).concat(' ').concat(reeferId.slice(4, 10)).concat(' ').concat(reeferId.slice(10, 11))
        } else {
            return "";
        }
    }
    bindCustomerData(customerAccessData: any) {
        if (customerAccessData != undefined) {
            this.setState({ CustomerGroups: JSON.parse(JSON.stringify(customerAccessData)), CustomerGroupsList: customerAccessData });
            if (customerAccessData.length > 0) {
                var defaultChecked = [];
                var defaultExpand = [];
                $.each(customerAccessData, function (index, value) {
                    if (value.isSelected == true) {
                        defaultExpand.push(value.value);
                    }
                    $.each(value.children, function (ind, val) {
                        if (val.isSelected == true) {
                            defaultChecked.push(val.value);
                        }
                    });
                });
                this.setState({ isLoading: false,  checked: defaultChecked, expanded: defaultExpand }, () => { lastCheckedNodes = this.state.checked });
            }
            else {
                lastCheckedNodes = [];
                this.setState({ isLoading: false, checked: [], expanded: [], CustomerGroups: [], CustomerGroupsList: [] });
            }
        }
    }

    componentWillReceiveProps(nextprops: any) {
        $('#globalLoader').show();

        var reeferData = nextprops.SelectedReefersData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            this.setState({ SelectedReefers: reeferData }, () => { this.bindCustomerData(nextprops.CustomerAccessData); });
        }
        selectedReefers = "";
        if (reeferData.length > 1) {
            $.each(reeferData, function (index, value) {
                selectedReefers = selectedReefers == "" ? this.GetFormatedReefer(value.AssetNumber) : selectedReefers + "," + this.GetFormatedReefer(value.AssetNumber);
            });
        }
        else {
            selectedReefers = this.GetFormatedReefer(reeferData[0].AssetNumber);
        }
        $('#globalLoader').hide();
        ////$('#globalLoader').show();
        //this.setState({ isLoading: true, collapsed: false, CustomerGroups: [], checked: [], expanded: [], CustomerGroupsList: [] });
        //if (nextprops.SelectedReefersData.length > 0 || nextprops.SelectedReefersData != undefined || nextprops.SelectedReefersData != null)
        //    this.bindCustomerData(nextprops.SelectedReefersData);
        ////$('#globalLoader').hide();
    }

    UnAssignFromCustomer() {
        if (this.state.checked.length > 0) {
            $('#globalLoader').show();
            var checkedGroupIds = [];
            var selUnits = [];
            var checkedList = this.state.checked;
            if (this.state.SelectedReefers.length > 1) {
                $.each(this.state.SelectedReefers, function (index, value) {
                    selectedUnits = selectedUnits == "" ? value.AssetMasterID : selectedUnits + "," + value.AssetMasterID;
                });
            }
            else {
                selectedUnits = this.state.SelectedReefers[0].AssetMasterID.toString();
            }

            $.each(selectedUnits.split(','), function (index, value) {
                selUnits.push(parseInt(value));
            });
            $.each(checkedList, function (index, value) {
                checkedGroupIds.push(parseInt(value.split(':')[1]));
            });

            var filterset: ParamsData = {
                SelectedUnits: selUnits,
                Groups: checkedGroupIds
            };

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/UnAssignUnitsFromGroups', { method: 'POST', body: JSON.stringify(filterset), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    if (data == "Unassigned") {
                        lastCheckedNodes = [];
                        //this.setState({ checked: lastCheckedNodes });
                        this.setState({ checked: lastCheckedNodes, IsCommandIssued: true, PrevSelectedItems: this.props.SelectedReefersData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.SelectedReefersData) });
                        this.props.refreshStatusGrid();                        
                        PopupWindow.showErrorMessage("Confirmation", "Selected Asset(s) have been successfully unassigned from the customer group(s).");
                        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
                    }
                    else {
                        PopupWindow.showErrorMessage("Confirmation", "Selected Asset(s) could not be unassigned from the customer group(s).");
                    }
                });
        }
        else {
            PopupWindow.showErrorMessage("Alert", "Please select at least one customer group.");            
        }
    }

    CloseModal() {
        lastCheckedNodes = [];
        this.setState({ checked: lastCheckedNodes });
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    public render() {
        const { checked, expanded } = this.state;

        return <div id="UnAssignAssetDiv" hidden={this.state.isLoading}>

            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-start">
                        <div className='fw-semibold'>Selected Asset(s): </div>
                        <div className='selected-assets fw-semibold'>{selectedReefers}</div>
                    </div>
                </div>
            </div>

            <div className="card mt-2">
                <div className="card-header">
                    Select the customer access group(s)
                </div>
                <div className="card-body custom-treeview max-height-20rem">
                    {this.state.CustomerGroups.length > 0 ? <CheckboxTree
                        checked={checked}
                        expanded={expanded}
                        nodes={this.state.CustomerGroups}
                        showNodeIcon={false}
                        disabled={true}
                    /> : null}
                </div>
            </div>

            <div className='modal-footer'>
                <button type='button' className='btn btn-secondary' onClick={this.CloseModal.bind(this)}>Cancel</button>
                <button type='button' className='btn btn-primary' onClick={this.UnAssignFromCustomer.bind(this)}>Save</button>
                   
                </div>
        </div>
    }
}

class ParamsData {
    SelectedUnits: any;
    Groups: any;    
}
class Customers {
    value: string;
    label: string;
    isSelected: boolean;
    disabled: boolean;
    children: CustomerAccessGroups[]
}
class CustomerAccessGroups {
    value: string;
    label: string;
    isSelected: boolean;
    disabled: boolean;
}
class AssignedUnitsList {
    UnitCustomerAccessGroupID: number;
    AssetMasterID: number;
    AssetNumber: string;
    CustomerID: number;
    CustomerAccessGroupID: number;
    Name: string;
}
